import { createFileRoute } from '@tanstack/react-router';
import { ClerkScope } from '../auth/ClerkScope';
import { RequireAuth } from '../auth/RequireAuth';
import { AuthorizePage } from '../pages/dashboard/authorize/AuthorizePage';

/** The route's typed search. Both keys are the literal URL parameter names and
 *  both are optional, because the router re-serializes whatever validateSearch
 *  returns back into the address bar: renaming `user_code` to `userCode` here,
 *  or defaulting either key to `''`, makes every visit redirect and rewrites the
 *  short link a human was handed into a noisy one. `user_code` is snake_case
 *  because that is the RFC 8628 parameter name in the gateway's verification URI. */
export interface AuthorizeSearch {
  request?: string;
  user_code?: string;
}

export const Route = createFileRoute('/dashboard_/authorize')({
  ssr: false,
  validateSearch: (search: Record<string, unknown>): AuthorizeSearch => {
    const out: AuthorizeSearch = {};
    if (typeof search.request === 'string' && search.request !== '') {
      out.request = search.request;
    }
    if (typeof search.user_code === 'string' && search.user_code !== '') {
      out.user_code = search.user_code;
    }
    return out;
  },
  component: AuthorizeRoute,
});

function AuthorizeRoute() {
  const { request = '', user_code: userCode = '' } = Route.useSearch();
  // Round-trip whichever param brought the human here, so signing in first still
  // lands them back on the right consent screen.
  const redirectUrl = userCode
    ? `/dashboard/authorize?user_code=${encodeURIComponent(userCode)}`
    : request
      ? `/dashboard/authorize?request=${encodeURIComponent(request)}`
      : '/dashboard/authorize';
  return (
    <ClerkScope>
      <RequireAuth redirectUrl={redirectUrl}>
        <AuthorizePage requestId={request} userCode={userCode} />
      </RequireAuth>
    </ClerkScope>
  );
}
